import styled, { css } from 'styled-components'
import { NavLink } from '../commons/link'

const linkStyles = `
  font-weight: 400;
  padding: 8px 10px 8px 30px;
  width: 100%;
  display: inline-block;
  &:hover {
    font-weight: 700;
  }
`

export const StyledMenuBaseLink = styled.a`
  ${linkStyles}
`

export const StyledMenuLink = styled(NavLink)`
  ${linkStyles}
`

export const StyledHeader = styled.header`
  & > nav {
    width: 100%;
    display: flex;
    padding: 0 30px 0 0;
    align-items: center;
    @media screen and (max-width: 1415px) {
      padding: 0 15px 0 0;
    }
    @media screen and (max-width: 480px) {
      padding: 0 5px 0 0;
    }
  }
  .logo-holder {
    z-index: 1000;
  }
`

export const LinksHolder = styled.div`
  flex-grow: 1;
  z-index: 1;
  display: flex;
  align-items: stretch;
  align-self: stretch;
  padding: 0 30px;
  @media screen and (max-width: 767px) {
    padding: 0;
  }
`

export const StyledMenuItemPanel = styled.div`
  position: absolute;
  display: none;
  align-items: stretch;
  top: 100%;
  left: 0;
  width: 100%;
  padding: 30px calc(50% - 600px) 50px;
  background: white;
  z-index: -1;
  box-shadow: 0px 4px 3px 1px rgba(0,0,0,0.15);
  min-height: 350px;
  & > * {
    flex: 0 0 calc(100% / 3);
  }

  &:before {
    position: absolute;
    content: '';
    background: rgb(0 0 0 / 70%);
    width: 100%;
    height: 100vh;
    z-index: -2;
    left: 0;
    top: 100%;
  }
`

export const Backdrop = styled.div`
  &:before {
    display: ${({ $open }) => $open ? 'block' : 'none'};
    content: '';
    background: rgb(0 0 0 / 70%);
    width: 100%;
    height: 100vh;
    top: ${({ $top }) => $top || 0}px;
    left: 0;
    z-index: -2;
    position: fixed;
  }
`

export const StyledMenuItem = styled.div`
  font-weight: 400;
  font-size: 18px;
  display: flex;
  padding: 0 20px;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;

  & > a[data-theme="public-spaces"] {
    font-weight: 700;
    color: #1e9d8b;
  }

  & > a > span {
    margin-left:4px;
    font-size: 80%;
    font-weight: 400;
    color: rgb(128, 128, 128);
  }

  & > a:not([href]):after {
    content: '\f078';
    font-weight: 700;
    font-family: 'Font Awesome 5 Free';
    margin-left: 8px;
    margin-top: -3px;
    vertical-align: initial;
    font-size: 80%;
    display: inline-block;
    -webkit-backface-visibility: hidden;
  }
  &:hover > a {
    color: #ff3700;
  }

  ${({ $open }) => $open ? css`
    & > a:after {
      transform: rotate(180deg);
    }

    & > a {
      color: #ff3700;
    }

    & ${StyledMenuItemPanel} {
      display: flex;
    }
  ` : ''}
`

export const StyledSubMenu = styled.ul`
  background: white;
  width: 100%;
  position: relative;
`
export const StyledSubSubMenu = styled(StyledSubMenu)`
  display: none;
  position: absolute;
  left: 100%;
  top: 0;
  z-index:10;
  background: rgb(245, 245, 245);
  background: linear-gradient(90deg, rgba(242, 242, 242, 1) 0%, rgba(255, 255, 255, 1) 100%);
  margin-top: -10px;
  padding: 10px 0;
`

export const StyledSubMenuItem = styled.div`
  width: 100%;
  border-left: 2px solid #ff3700;
  &:hover > ${StyledMenuLink} {
    font-weight: 700;
  }

  ${({ $hasSubMenu }) => $hasSubMenu ? css`
    ${({ $hover }) => $hover ? css`
      background: rgb(245, 245, 245);
      background: linear-gradient(270deg, rgba(242, 242, 242, 1) 0%, rgba(255, 255, 255, 1) 100%);
    `: ''}
  `: ''}

  ${({ $hover }) => $hover ? css`
    & ${StyledSubSubMenu} {
      display: block;
      min-height: 100%;
    }
  `: ''}

`

export const StyledPoster = styled(NavLink)`
  display: flex;
  flex-direction: column;
  padding: 0 30px;
  p {
    font-size: 16px;
    margin-top: 4px;
    white-space: normal;
  }
  &:hover p {
    color: #ff3700
  }
  & img {
    max-width: 100%;
    width: 100%;
  }

`